const NO_NUMBER_VALUES = new Set(['', 'n/a', 'na', 'none', 'null', 'undefined', '-', '—', '–'])

/**
 * True when a stored setNumber is a real collector number. Sealed product and unnumbered cards
 * store "N/A" or an empty string instead, which must never be printed as "#N/A".
 * Mirrored by backend/src/catalog/card-identity.ts.
 */
export function hasCardNumber(value: string | null | undefined): value is string {
  return !NO_NUMBER_VALUES.has(String(value ?? '').trim().toLowerCase())
}
